import { render, staticRenderFns } from "./MajorMediaPage.vue?vue&type=template&id=14e499ea&scoped=true"
import script from "./MajorMediaPage.vue?vue&type=script&lang=js"
export * from "./MajorMediaPage.vue?vue&type=script&lang=js"
import style0 from "./MajorMediaPage.vue?vue&type=style&index=0&id=14e499ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e499ea",
  null
  
)

export default component.exports